import { RadioGroup, RadioGroupItem } from "@/components/ui/radio-group";
import { AnswerEvaluation } from "@/schema/console/checking-assessments/AnswerEvaluation";
import { useTranslation } from "react-i18next";

interface Props {
  evaluation: AnswerEvaluation;
  index: number;
}

function AccessorCheckItem({ evaluation, index }: Props) {
  const { t } = useTranslation();
  return (
    <div className=" flex flex-col space-y-4">
      <p className="text-sm font-normal text-cool-gray-700">
        {`${index}. ${evaluation.content}`}
      </p>
      <RadioGroup disabled value={`${evaluation.evaluation_rate}`}>
        <div className=" flex flex-row space-x-4">
          <div className=" flex flex-row space-x-2">
            <RadioGroupItem value={"0"} />
            <label htmlFor="0">{t("ineligible")}</label>
          </div>
          <div className=" flex flex-row border-l border-l-cool-gray-300 pl-4 space-x-4">
            <div className=" flex flex-row space-x-2">
              <RadioGroupItem value={"1"} />
              <label htmlFor="1">0%</label>
            </div>
            <div className=" flex flex-row space-x-2">
              <RadioGroupItem value={"2"} />
              <label htmlFor="2">50%</label>
            </div>
            <div className=" flex flex-row space-x-2">
              <RadioGroupItem value={"3"} />
              <label htmlFor="3">100%</label>
            </div>
          </div>
        </div>
      </RadioGroup>
      {evaluation.comment && (
        <p className=" text-sm font-normal text-cool-gray-600">
          {`${t("memo")}: ${evaluation.comment}`}
        </p>
      )}
    </div>
  );
}

export default AccessorCheckItem;
